import React from "react";
import { IoMdChatbubbles } from "react-icons/io";

function NoConversationSelectedComponent() {
  return (
    <div className="flex h-[85vh] flex-col items-center justify-center gap-4 px-6 text-center">
      {/* icon in soft circle */}
      <div className="flex h-24 w-24 items-center justify-center rounded-full bg-zinc-800/80 ring-1 ring-white/10">
        <IoMdChatbubbles className="text-5xl text-zinc-500" />
      </div>

      <div>
        <h3 className="text-lg font-semibold text-white">
          No conversation selected
        </h3>
        <p className="mt-1 max-w-xs text-sm text-zinc-500">
          Choose a conversation from the list to start chatting.
        </p>
      </div>
    </div>
  );
}

export default NoConversationSelectedComponent;